/**
 * A ceiling on how many of one kind of request are in flight at once.
 *
 * Browsers allow about six connections per host. Anything past that queues — and the
 * queue is shared, so a screen that fires forty image requests at once does not merely
 * load slowly: it stalls *every* later request behind them, including the POST from a
 * button the person clicks while looking at the result. That happened here. A document
 * picker rendered a thumbnail per document, and the extract request sat unsent behind
 * thirty-odd page renders, some of them seven megabytes.
 *
 * So bulk, low-value work takes a lane and leaves the rest of the connection budget for
 * requests a person is waiting on.
 */
export function lanes(limit: number) {
  let active = 0;
  const waiting: (() => void)[] = [];

  async function run<T>(task: () => Promise<T>): Promise<T> {
    if (active >= limit) await new Promise<void>((resolve) => waiting.push(resolve));
    active += 1;
    try {
      return await task();
    } finally {
      active -= 1;
      waiting.shift()?.();
    }
  }

  return { run };
}
